// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d175a1cf","239":"434647e3","455":"ffe655c0"}[chunkId] + ".chunk.js";
};